import { render } from "./LanguagesSection.vue?vue&type=template&id=3586ec57"
import script from "./LanguagesSection.vue?vue&type=script&lang=js"
export * from "./LanguagesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__